import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { SkillPracticeTaskResponse } from '../models/skill-learning.model';
import { SKILL_PRACTICE_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillPracticeApiService {

  constructor(private http: Http) {}

  startPracticeLevel(specializationId: string, level: number): Observable<SkillPracticeTaskResponse> {
    return this.http
      .post(SKILL_PRACTICE_API.START(specializationId, level), null)
      .map(response => response.json() as SkillPracticeTaskResponse);
  }

  fetchPracticeTask(specializationId: string, level: number): Observable<SkillPracticeTaskResponse> {
    return this.http
      .get(SKILL_PRACTICE_API.TASK(specializationId, level))
      .map(response => response.json() as SkillPracticeTaskResponse);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-practice-api.service.ts